import Placement from "./Placement";

class City extends Placement {
  CONGRATULATION = 'нашёл все города в игре';
  CONGRATULATION_PLURAL = 'нашли все города в игре';
  HEADER = 'Города'
  CAPTION = 'Нажмите на город с заданным названием.'
}

export default City;
